module.exports = __webpack_public_path__ + "img/home (21).79241e37.png";